import { useTheme } from "@mui/material";
import { ReactNode, Ref } from "react";
import SimpleBarCore from "simplebar-core";
import SimpleBar from "simplebar-react";

import { ToggleSidebarButton } from "./ToggleSidebarButton";

import useSidebarStore from "@/hooks/zustand/ui/useSidebarStore";
import { CONTENT_HEIGHT, HEADER_HEIGHT, PROTRUDING_EDGE_WIDTH, SIDEBAR_TRANSITIONS } from "@/layouts/constants";

interface SidebarProps {
  children: ReactNode;
  hideable?: boolean;
  sidebarWidth: number;
  ref?: Ref<SimpleBarCore | null> | undefined;
}

export function Sidebar({ children, ref, hideable = false, sidebarWidth }: SidebarProps) {
  const theme = useTheme();
  const { sidebarOpen } = useSidebarStore();
  const isSidebarOpen = sidebarOpen || !hideable;

  return (
    <>
      {hideable && <ToggleSidebarButton sidebarWidth={sidebarWidth} />}
      <SimpleBar
        ref={ref}
        style={{
          width: sidebarWidth,
          height: CONTENT_HEIGHT,
          top: HEADER_HEIGHT,
          paddingBottom: 16,
          paddingTop: 16,
          backgroundColor: theme.palette.background.paper,
          borderRight: `1px solid ${theme.palette.divider}`,
          flexShrink: 0,
          position: "absolute",
          transition: SIDEBAR_TRANSITIONS,
          marginLeft: isSidebarOpen ? 0 : -sidebarWidth + PROTRUDING_EDGE_WIDTH,
          pointerEvents: isSidebarOpen ? undefined : "none",
          zIndex: 2,
        }}
      >
        {children}
      </SimpleBar>
    </>
  );
}
